import { core_backend_url } from "../../config"

export const adminApi = {
    activateUser: (userId) => core_backend_url + 'user/' + userId + '/activate',
    deactivateUser: (userId) => core_backend_url + 'user/' + userId + '/deactivate',
    reassign: (userId) => core_backend_url + 'user/' + userId + '/reassign',
    create: core_backend_url + 'auth/admin/user',
    getAllUsers: core_backend_url + 'user/all',
    getDashboard: core_backend_url + 'dashboard',
    getAllCertificates: (status) => core_backend_url + 'certificate/admin/all?status=' + status
};